export function slimDownName(str: string) {
  const slimmedName = str
    .replace(/\s/g, "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
  return slimmedName;
}
